import { useId } from "react";

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_887609ba-6faf-4c1b-bec9-34092c9a600f/artifacts/kpsi58qb_Screenshot%202026-06-22%20alle%2019.46.46.png";

export const CART_IMG =
  "https://static.prod-images.emergentagent.com/jobs/887609ba-6faf-4c1b-bec9-34092c9a600f/images/824a848511a48d65f97009f24f71fbd1ba489fd1a6f6ec2594ff3721ecb52872.png";

export const XXI_LOGO =
  "https://customer-assets.emergentagent.com/job_chiara-premium-cafe/artifacts/66qkdh9p_Screenshot%202026-07-12%20alle%2020.55.43.png";

export const MOOD_IMG =
  "https://static.prod-images.emergentagent.com/jobs/887609ba-6faf-4c1b-bec9-34092c9a600f/images/c7c4c13c5bf06ddc047ba3066eeb96b67f71bdabbe6b839fa066039a916cdbd0.jpeg";

/* Santa Chiara wordmark — reuses the brand asset and knocks out the
   powder-blue background with a colour matrix so it sits on any surface. */
export const LogoMark = ({ className = "", viewBox = "70 400 860 250" }) => {
  const fid = useId().replace(/:/g, "");
  return (
    <svg
      viewBox={viewBox}
      className={className}
      role="img"
      aria-label="Santa Chiara"
    >
      <defs>
        <filter id={`drop-${fid}`} colorInterpolationFilters="sRGB">
          <feColorMatrix
            type="matrix"
            values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  25 0 -24 0 0"
          />
        </filter>
      </defs>
      <image
        href={LOGO_URL}
        x="0"
        y="0"
        width="1000"
        height="1000"
        preserveAspectRatio="xMidYMid meet"
        filter={`url(#drop-${fid})`}
      />
    </svg>
  );
};

/* Exact stylized golden gelato cone reused from the gelato-builder project. */
export const GelatoCone = ({ className = "" }) => (
  <svg
    viewBox="0 0 200 280"
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-label="Stylized golden gelato cone"
  >
    <defs>
      <linearGradient id="scoopGrad" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0%" stopColor="#D4B989" />
        <stop offset="60%" stopColor="#B89968" />
        <stop offset="100%" stopColor="#9A7E52" />
      </linearGradient>
      <linearGradient id="coneGrad" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0%" stopColor="#B89968" />
        <stop offset="100%" stopColor="#9A7E52" />
      </linearGradient>
    </defs>
    <circle cx="100" cy="80" r="48" fill="url(#scoopGrad)" />
    <circle cx="78" cy="105" r="36" fill="url(#scoopGrad)" opacity="0.95" />
    <circle cx="122" cy="108" r="34" fill="url(#scoopGrad)" opacity="0.92" />
    <circle cx="100" cy="128" r="38" fill="url(#scoopGrad)" />
    <ellipse cx="86" cy="62" rx="14" ry="8" fill="#D4B989" opacity="0.55" />
    <path d="M55 150 L145 150 L100 268 Z" fill="url(#coneGrad)" />
    <g stroke="#9A7E52" strokeWidth="1.2" opacity="0.55">
      <line x1="68" y1="170" x2="120" y2="170" />
      <line x1="74" y1="190" x2="126" y2="190" />
      <line x1="80" y1="210" x2="120" y2="210" />
      <line x1="88" y1="230" x2="112" y2="230" />
      <line x1="70" y1="155" x2="110" y2="255" />
      <line x1="90" y1="155" x2="100" y2="270" />
      <line x1="110" y1="155" x2="92" y2="265" />
      <line x1="130" y1="155" x2="90" y2="255" />
    </g>
    <ellipse
      cx="100"
      cy="150"
      rx="45"
      ry="6"
      fill="#B89968"
      stroke="#9A7E52"
      strokeWidth="1.5"
    />
    <g fill="#D4B989" opacity="0.9">
      <path d="M150 40 l3 8 8 3 -8 3 -3 8 -3 -8 -8 -3 8 -3 z" />
      <path d="M40 130 l2 5 5 2 -5 2 -2 5 -2 -5 -5 -2 5 -2 z" />
    </g>
  </svg>
);
